module.exports = __webpack_public_path__ + "img/down-arrow.de8dad13.svg";